<template>
  <form @submit.prevent="handleSubmit">
    <modal-card :title="$t('upload_image')">
      <img v-if="!config.croppable" :src="src" />

      <crop-image
        v-else
        ref="cropImage"
        :src="src"
        :options="config.croppie"
        @cropped="file => $refs.uploader.upload(file)"
      ></crop-image>

      <div slot="foot">
        <upload-file
          ref="uploader"
          :file-field-name="config.fileFieldName"
          file-name="image.jpg"
          :additional="config.additional"
          :endpoint="config.endpoint"
          @uploaded="uploaded"
        >
          <template slot-scope="{ progress }">
            <button type="submit" class="button" @click="$parent.close()">{{ $t("cancel") }}</button>

            <button
              class="button is-primary"
              :class="{
                'is-loading': progress !== null
              }"
            >{{ $t("upload_image") }}</button>
          </template>
        </upload-file>
      </div>
    </modal-card>
  </form>
</template>

<script>
import i18n from "./../i18n";
import CropImage from "./CropImage";
import UploadFile from "./UploadFile";

export default {
  i18n,

  components: {
    UploadFile,
    CropImage
  },

  props: {
    config: {
      type: Object,
      required: true
    },

    file: {
      required: true
    },

    whenUploaded: {
      type: Function
    }
  },

  data() {
    return {
      uploading: false
    };
  },

  computed: {
    src() {
      return URL.createObjectURL(this.file);
    }
  },

  methods: {
    handleSubmit() {
      if (this.config.croppable) {
        return this.$refs.cropImage.crop();
      }

      this.$refs.uploader.upload(this.file);
    },

    uploaded({ data: image }) {
      this.whenUploaded(image);

      this.$parent.close();
    }
  }
};
</script>
